const dispatchSelectLoaded = (element) => {
  element.dispatchEvent(new Event('select:loaded'));
}

export default dispatchSelectLoaded;